export enum ExpenseType {
  Installment = 1,
  RecurringCard = 2,
  RecurringOffCard = 3
}

export interface ExpenseDto {
  id: string;
  name: string;
  originalName?: string | null;
  amount: number;
  type: ExpenseType;
  installments?: number | null;
  purchaseDate?: string | null;
  dueDate?: string | null;
  dueDay?: number | null;
  autoPayment?: boolean;
  includeInForecast?: boolean;
  isActive: boolean;
  createdAt: string;
  creditCardId?: string | null;
}

export interface EntryDto {
  id: string;
  name: string;
  amount: number;
  month: number;
  year: number;
  isSalary: boolean;
  createdAt: string;
}

export interface NewInstallmentExpense {
  name: string;
  amount: number | '';
  installments: number | '';
  originalName?: string;
  purchaseDate?: string | null;
  dueDate?: string | null;
  autoPayment?: boolean;
  includeInForecast?: boolean;
  creditCardId?: string | null;
}

export interface NewRecurringExpense {
  name: string;
  amount: number | '';
  onCard: boolean;
  originalName?: string;
  dueDate?: string;
  dueDay?: number | '';
  autoPayment?: boolean;
  includeInForecast?: boolean;
  creditCardId?: string | null;
}

export interface EditExpenseModel {
  id: string;
  name: string;
  originalName?: string | null;
  amount: number | '';
  type: ExpenseType;
  installments?: number | null;
  purchaseDate?: string | null;
  dueDate?: string | null;
  dueDay?: number | null;
  autoPayment: boolean;
  includeInForecast: boolean;
  isActive: boolean;
  creditCardId?: string | null;
}

export interface NewEntry {
  name: string;
  amount: number | '';
  month: number;
  year: number;
  isSalary: boolean;
}

export interface ClosingCommitmentDto {
  expenseId?: string | null;
  name: string;
  amount: number;
  isIncluded: boolean;
  includeInForecast: boolean;
  updateFutureAmount: boolean;
  paidAnotherWay: boolean;
  paymentMethodNote?: string | null;
}

export interface ClosingCardDto {
  creditCardId?: string | null;
  name: string;
  baseAmount: number;
  amount: number;
  amountOverridden: boolean;
  isIncluded: boolean;
  isPaid: boolean;
  paymentMethodNote?: string | null;
}

export interface SaveClosingDraftCard {
  creditCardId: string;
  amount: number;
  isIncluded: boolean;
  isPaid: boolean;
  paymentMethodNote?: string | null;
}

export interface SaveClosingDraftCommitment {
  expenseId: string;
  amount: number;
  isIncluded: boolean;
  updateFutureAmount: boolean;
  paidAnotherWay: boolean;
  paymentMethodNote?: string | null;
}

export interface FinancialAdjustmentDto {
  id: string;
  description: string;
  amount: number;
  createdAt: string;
}

export interface ExpenseAmountChangeDto {
  id: string;
  expenseId: string;
  expenseName: string;
  previousAmount: number;
  newAmount: number;
  changedAt: string;
}

export interface MonthlyClosingDto {
  id: string;
  year: number;
  month: number;
  isFinalized: boolean;  previousResidual: number;
  totalEntries: number;
  totalSalaryEntries: number;
  commitments: ClosingCommitmentDto[];
  totalCommitments: number;
  cards: ClosingCardDto[];
  totalCards: number;
  adjustments: FinancialAdjustmentDto[];
  totalAdjustments: number;
  residualBalance: number;
  forecastIncome: number;
  forecastExpenses: number;
  forecastBalance: number;
  amountChanges: ExpenseAmountChangeDto[];
  finalizedAt?: string | null;
  userSavedDraft: boolean;
}

export interface MonthlyClosingSummaryDto {
  year: number;
  month: number;
  residualBalance: number;
  forecastIncome: number;
  forecastExpenses: number;
  forecastBalance: number;
  finalizedAt?: string | null;
}

export interface UserDto {
  id: string;
  email: string;
  name: string;
  givenName?: string | null;
  familyName?: string | null;
  pictureUrl?: string | null;
}

export interface AuthResponse {
  token: string;
  user: UserDto;
}

export interface MonthlyForecastDto {
  year: number;
  month: number;
  previousResidual: number;
  totalEntries: number;
  totalCommitments: number;
  totalCards: number;
  totalAdjustments: number;
  balance: number;
}

export interface CreditCardDto {
  id: string;
  name: string;
  brand?: string | null;
  lastFourDigits?: string | null;
  limit?: number | null;
  closingDay?: number | null;
  dueDay?: number | null;
  isActive: boolean;
  createdAt: string;
}

export interface NewCreditCard {
  name: string;
  brand?: string;
  lastFourDigits?: string;
  limit?: number | '';
  closingDay?: number | '';
  dueDay?: number | '';
  isActive?: boolean;
}
